import { css } from 'styled-components';

const scrollbarStyle = {
  componentScrollbar: css(["&::-webkit-scrollbar{width:", ";height:", ";}&::-webkit-scrollbar-track{background-color:", ";}&::-webkit-scrollbar-thumb{border:", " transparent;border-radius:", ";border-color:", ";background-color:", ";min-height:", ";min-width:", ";}&:hover{&::-webkit-scrollbar-thumb{background-color:", ";}}scrollbar-width:", ";scrollbar-color:", " ", ";"], ({
    theme
  }) => theme.components.scrollbars.webkit.component.width, ({
    theme
  }) => theme.components.scrollbars.webkit.component.width, ({
    theme
  }) => theme.components.scrollbars.webkit.component.trackBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.webkit.component.thumbBorder, ({
    theme
  }) => theme.components.scrollbars.webkit.component.thumbBorderRadius, ({
    theme
  }) => theme.components.scrollbars.webkit.component.thumbBorderColor, ({
    theme
  }) => theme.components.scrollbars.webkit.component.trackBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.webkit.component.thumbMinHeight, ({
    theme
  }) => theme.components.scrollbars.webkit.component.thumbMinHeight, ({
    theme
  }) => theme.components.scrollbars.webkit.component.thumbBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.standard.width, ({
    theme
  }) => theme.components.scrollbars.standard.component.thumbBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.standard.component.trackBackgroundColor),
  pageScrollbar: css(["&::-webkit-scrollbar{width:", ";height:", ";}&::-webkit-scrollbar-track{background-color:", ";}&::-webkit-scrollbar-thumb{border:", " transparent;border-radius:", ";border-color:", ";background-color:", ";min-height:", ";min-width:", ";}scrollbar-width:", ";scrollbar-color:", " ", ";"], ({
    theme
  }) => theme.components.scrollbars.webkit.page.width, ({
    theme
  }) => theme.components.scrollbars.webkit.page.width, ({
    theme
  }) => theme.components.scrollbars.webkit.page.trackBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.webkit.page.thumbBorder, ({
    theme
  }) => theme.components.scrollbars.webkit.page.thumbBorderRadius, ({
    theme
  }) => theme.components.scrollbars.webkit.page.thumbBorderColor, ({
    theme
  }) => theme.components.scrollbars.webkit.page.thumbBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.webkit.page.thumbMinHeight, ({
    theme
  }) => theme.components.scrollbars.webkit.page.thumbMinHeight, ({
    theme
  }) => theme.components.scrollbars.standard.width, ({
    theme
  }) => theme.components.scrollbars.standard.page.thumbBackgroundColor, ({
    theme
  }) => theme.components.scrollbars.standard.page.trackBackgroundColor)
};

export { scrollbarStyle };
//# sourceMappingURL=scrollbarStyle.js.map
